import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { useDebouncedCallback } from 'use-debounce';
import { _ } from '_locales';
import { colors } from '_styles';
import { cts_secure } from '_cts';
import apis from '_apis';
import { connect } from 'react-redux';
import { zone as zoneSetup } from '_actions';
import { Input } from '_components';
import { confirmHandler, getZone } from '../../ZoneSetupScreens/utils';
import Loader from '../../ZoneSetupScreens/components/ZoneSetupSearch/Loader';

/**
 *
 * import styles
 */
const parentWidth = document.getElementById('rcroot').getBoundingClientRect().width;

const Container = styled.div`
  background-color: #fff;
  max-width: 577px;
  margin: 45px auto;
`;

const SearchInputContainer = styled.div`
  width: calc(100% - 185px);
  float: left;
  margin-top: 3px;
  border-radius: 15px 0 0 15px;

  input {
    border-radius: 15px 0 0 15px;

    &:focus {
      outline: none !important;
      box-shadow: 0 0 2px 2px #51a7e8;
      border-radius: 15px 0 0 15px;
    }
  }

  @media screen and (max-width: 500px) {
    width: 100%;
    border-radius: 15px;
    float: initial;

    input {
      border-radius: 15px;

      &:focus {
        outline: none !important;
        box-shadow: 0 0 2px 2px #51a7e8;
        border-radius: 15px;
      }
    }
  }

  ${(parentWidth < 501) && css`
    width: 100%;
    border-radius: 15px;
    float: initial;

    input {
      border-radius: 15px;

      &:focus {
        outline: none !important;
        box-shadow: 0 0 2px 2px #51a7e8;
        border-radius: 15px;
      }
    }
  `};
`;

const inputStyle = {
  width: '100%',
  border: 'none',
  backgroundColor: '#f3f2f2',
  fontSize: '14px',
  fontFamily: 'Roboto,sans-serif',
  color: '#000',
  fontWeight: '400',
  padding: '23px',
  boxSizing: 'border-box',
  height: 22,
  lineHeight: '15px',
};

const ConfirmInputContainer = styled.div`
  width: 185px;
  border-radius: 0 15px 15px 0;
  margin-top: 3px;
  display: inline-block;

  input {
    border-radius: 0 15px 15px 0;

    &:focus {
      outline: none !important;
      box-shadow: 0 0 2px 2px #51a7e8;
    }
  }

  @media screen and (max-width: 500px) {
    display: none;

    input,
    label {
      display: none;
    }
  }

  ${(parentWidth < 501) && css`
    display: none;

    input,
    label {
      display: none;
    }
  `};
`;

const submitInputStyle = {
  width: '100%',
  border: 'none',
  fontSize: '14px',
  fontFamily: 'Roboto,sans-serif',
  color: '#f3f2f2',
  fontWeight: '500',
  padding: '23px',
  boxSizing: 'border-box',
};

const InputHolder = styled.div`
   width: 100%;
   max-width: 577px;
   position: relative;
   margin: 0 auto;
   box-sizing: border-box;
   background-color: white;
   padding-bottom: 10px;
   &.before-search {
    z-index: 1;
   }

   @media screen and (max-width: 500px) {
    padding-top: 30px !important;
   }

  ${(parentWidth < 501) && css`
    padding-top: 30px !important;
  `};
`;

const Label = styled.label`
   font-size: 14px !important;
   font-weight: 400 !important;
   font-family: Roboto,sans-serif !important;
   font-stretch: normal !important;
   font-style: normal !important;
   line-height: 1.36;
   letter-spacing: normal;
   text-align: left;
   color: #0a1514;
   display: block;
   margin-bottom: 11px;

   @media screen and (max-width: 500px) {
    font-size: 20px !important;
    text-align: center !important;
    margin-bottom: 30px !important;
   }

  ${(parentWidth < 501) && css`
    font-size: 20px !important;
    text-align: center !important;
    margin-bottom: 30px !important;
  `};
`;

const ErrorText = styled.p`
  font-weight: 400 !important;
  font-size: 14px !important;
  font-family: Roboto, sans-serif !important;
  color: #E72929;
`;

const Ul = styled.ul`
    position: relative;
    width: 100%;
    margin: 0;
    padding: 13px 0px;
    box-sizing: border-box;
    list-style-type: none !important;
`;

const Li = styled.li``;

const Item = styled.button`
  border: none;
  background-color: transparent;
  font-size: 15px !important;
  color: ${colors.RC_ACTION} !important;
  line-height: 1.7em;
  text-align: left;
  display: block;
  cursor: pointer;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  padding: 7px 10px;
  width: 100%;
  text-decoration: none !important;
  border-radius: 3px;
  transition: 0.2s;
  
  &:hover {
    text-decoration: none !important;
    background-color: #EEEDEE;
    color: ${colors.RC_ACTION} !important;
  }
`;

// End styles

const AddressSetupMap = ({
  plugin,
  config,
  setCoordinate,
  setAddressDetails,
  setCurrentPage,
  currentPage,
  setAddressSearchType
}) => {
  /* Define the states from redux */
  const { projectId, uuid } = plugin;
  const { districtId, webappConfig } = config;
  const { address_message = null } = webappConfig;
  const { main_color = '' } = config.templateColour ? JSON.parse(config.templateColour) : {};

  /* Hooks */
  const [addressNotFound, setAddressNotFound] = useState(false);
  const [term, setTerm] = useState('');
  const [contentLoading, setContentLoading] = useState(false);
  const [address, setAddress] = useState([]);
  const [invalidZone, setInvalidZone] = useState();
  const [zoneString, setZoneString] = useState();
  const history = useHistory();

  /* Go to the list search page */

  const navigateZoneSetupList = () => setAddressSearchType('list');

  useEffect(() => {
    setAddressNotFound(false);
    setInvalidZone(false);
  }, [term]);

  useEffect(() => {
    if (zoneString) {
      setAddressDetails({
        projectId,
        districtId,
        zoneString,
        address: address[0].address,
      });
      setCurrentPage(currentPage + 1);
    }
  }, [zoneString]);

  /* Confirm the zone */
  const selectAddress = async (lat, lng, address) => {
    if (!lat || !lng || !address) {
      throw new Error('Address, lat or lng is undefined!');
    }
    try {
      setContentLoading(true);

      const zoneObject = await getZone(projectId, districtId, lat, lng);
      setCoordinate({ lat, lng });

      if (!zoneObject || !zoneObject.length) {
        throw new Error(`zoneObject is invalid ${zoneObject}`);
      }

      const confirmStatus = await confirmHandler(history, 'map', zoneObject, address, '', setZoneString);

      // setContentLoading(false);
    } catch ({ message }) {
      setInvalidZone(true);
      setContentLoading(false);
    }
  };

  const getCoordsForAddress = async (term) => {
    if (term.length > 2) {
      setContentLoading(true);
      try {
        const { data, status } = await cts_secure('get', apis.getLatAndLong(term, uuid, projectId, districtId));
        if (
          status !== 200
          || !data
          || data.length <= 0
        ) {
          setAddressNotFound(true);
        }

        setAddress(data);
        setContentLoading(false);
      } catch ({ message }) {
        setAddressNotFound(true);
        setContentLoading(false);
      }
    }
  };

  /**
   * Prevent race Condition
   */
  const [debouncedFetchResult] = useDebouncedCallback(
    getCoordsForAddress,
    700
  );

  const onChange = async ({ target }) => {
    setTerm(target.value);
    debouncedFetchResult(target.value);
  };

  return (
    <Container>
      <InputHolder className="before-search">
        <Label htmlFor="g-addr-search1">{address_message || _('zone.find_out_your_waste_and_recycling_pickup_schedule')}</Label>
        <SearchInputContainer>
          <input
            type="text"
            id="g-addr-search1"
            onChange={(e) => onChange(e)}
            onKeyDown={(e) => e.stopPropagation()}
            placeholder={_('zone.your_home_address')}
            style={inputStyle}
            aria-label="Enter your home address"
          />
        </SearchInputContainer>
        <ConfirmInputContainer>
          <label htmlFor="submit-my-schedule" style={{ display: 'none' }}>{_('zone.show_my_schedule')}</label>
          <Input
            type="submit"
            id="submit-my-schedule"
            style={{
              ...submitInputStyle,
              backgroundColor: (main_color ? `#${main_color}` : colors.RC_ACTION)
            }}
            value={_('zone.show_my_schedule')}
            ariaLabel={_('zone.show_my_schedule')}
          />
        </ConfirmInputContainer>
        {addressNotFound && <ErrorText>{_('zone.address_not_found')}</ErrorText>}

        {invalidZone && (
          <ErrorText>
            {_('zone.address_not_found')}
          </ErrorText>
        )}
      </InputHolder>

      {contentLoading ? (<Loader />) : (
        <>
          {
            (address && !addressNotFound && !invalidZone && address.length && term.length > 2) ? (
              <Ul>
                {address
                  .filter((_, index) => index < 10).map((item) => (
                    <Li>
                      <Item
                        onClick={() => selectAddress(item.lat, item.lng, item.address)}
                        title="Click to confirm area"
                      >
                        {item.address}
                      </Item>
                    </Li>
                  ))}
              </Ul>
            ) : null
          }
        </>
      )}
    </Container>
  );
};

const mapStateToProps = (store) => ({
  customColors: store.config.templateColour
    ? JSON.parse(store.config.templateColour)
    : {},
  config: store.config,
  plugin: store.plugin,
});

const mapDispatchToProps = (dispatch) => ({
  setCoordinate: (coordinate) => dispatch(zoneSetup.setCoordinate(coordinate)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddressSetupMap);
